import { useEffect, useState } from 'react'
import { Row, Col } from 'antd'
import Style from './record.module.scss'
import { GET_RECORDDETAIL } from '../../../../api/MaterialApi'
import { GET_RECORDBRANDDETAIL } from '../../../../api/BrandApi'
interface Props {
  id?: string
  type: 1 | 2 // 1 物料 2品牌
}

// 操作记录
const Record = (props: Props) => {
  const { type, id } = props
  const [dataSource, setDataSource] = useState<{
    assessMan: string
    assessTime: string
    createMan: string
    createTime: string
    disableMan: string
    disableTime: string
    updateMan: string
    updateTime: string
  }>()
  useEffect(() => {
    if (id) {
      getData(id)
    }
    // eslint-disable-next-line
  }, [])

  // 获取记录信息
  async function getData(id: string) {
    let resData: any
    if (type === 1) {
      resData = await GET_RECORDDETAIL({ productId: id })
    }
    if (type === 2) {
      resData = await GET_RECORDBRANDDETAIL({ brandId: id })
    }
    if (resData.code === 0) {
      const data = resData.data
      setDataSource({
        assessMan: data.assessMan, // 审核人
        assessTime: data.assessTime, // 审核时间
        createMan: data.createMan, // 创建人
        createTime: data.createTime, // 创建时间
        disableMan: data.disableMan, // 禁用人
        disableTime: data.disableTime, // 禁用时间
        updateMan: data.updateMan, // 修改人
        updateTime: data.updateTime, // 修改时间
      })
    }
  }
  return (
    <div className={Style.box}>
      <Row className={Style.rowitem}>
        <Col span={12} className={Style.leftcol}>
          创建人：{dataSource?.createMan}
        </Col>
        <Col span={12} className={Style.rightcol}>
          创建时间：{dataSource?.createTime}
        </Col>
      </Row>
      <Row className={Style.rowitem}>
        <Col span={12} className={Style.leftcol}>
          修改人：{dataSource?.updateMan}
        </Col>
        <Col span={12} className={Style.rightcol}>
          修改时间：{dataSource?.updateTime}
        </Col>
      </Row>
      <Row className={Style.rowitem}>
        <Col span={12} className={Style.leftcol}>
          审核人：{dataSource?.assessMan}
        </Col>
        <Col span={12} className={Style.rightcol}>
          审核时间：{dataSource?.assessTime}
        </Col>
      </Row>
      <Row className={Style.rowitem}>
        <Col span={12} className={Style.leftcol}>
          禁用人：{dataSource?.disableMan}
        </Col>
        <Col span={12} className={Style.rightcol}>
          禁用时间：{dataSource?.disableTime}
        </Col>
      </Row>
      {/* <Row className={Style.rowitem}>
				<Col span={12} className={Style.leftcol}>
					启用人：{dataSource?.disableMan}
				</Col>
				<Col span={12} className={Style.rightcol}>
					启用时间：{dataSource?.disableMan}
				</Col>
			</Row> */}
    </div>
  )
}

export default Record
import { useEffect, useState } from 'react'
import { Row, Col } from 'antd'
import Style from './record.module.scss'
import { GET_RECORDDETAIL } from '../../../../api/MaterialApi'
import { GET_RECORDBRANDDETAIL } from '../../../../api/BrandApi'
interface Props {
  id?: string
  type: 1 | 2 // 1 物料 2品牌
}

// 操作记录
const Record = (props: Props) => {
  const { type, id } = props
  const [dataSource, setDataSource] = useState<{
    assessMan: string
    assessTime: string
    createMan: string
    createTime: string
    disableMan: string
    disableTime: string
    updateMan: string
    updateTime: string
  }>()
  useEffect(() => {
    if (id) {
      getData(id)
    }
    // eslint-disable-next-line
  }, [])

  // 获取记录信息
  async function getData(id: string) {
    let resData: any
    if (type === 1) {
      resData = await GET_RECORDDETAIL({ productId: id })
    }
    if (type === 2) {
      resData = await GET_RECORDBRANDDETAIL({ brandId: id })
    }
    if (resData.code === 0) {
      const data = resData.data
      setDataSource({
        assessMan: data.assessMan, // 审核人
        assessTime: data.assessTime, // 审核时间
        createMan: data.createMan, // 创建人
        createTime: data.createTime, // 创建时间
        disableMan: data.disableMan, // 禁用人
        disableTime: data.disableTime, // 禁用时间
        updateMan: data.updateMan, // 修改人
        updateTime: data.updateTime, // 修改时间
      })
    }
  }
  return (
    <div className={Style.box}>
      <Row className={Style.rowitem}>
        <Col span={12} className={Style.leftcol}>
          创建人：{dataSource?.createMan}
        </Col>
        <Col span={12} className={Style.rightcol}>
          创建时间：{dataSource?.createTime}
        </Col>
      </Row>
      <Row className={Style.rowitem}>
        <Col span={12} className={Style.leftcol}>
          修改人：{dataSource?.updateMan}
        </Col>
        <Col span={12} className={Style.rightcol}>
          修改时间：{dataSource?.updateTime}
        </Col>
      </Row>
      <Row className={Style.rowitem}>
        <Col span={12} className={Style.leftcol}>
          审核人：{dataSource?.assessMan}
        </Col>
        <Col span={12} className={Style.rightcol}>
          审核时间：{dataSource?.assessTime}
        </Col>
      </Row>
      <Row className={Style.rowitem}>
        <Col span={12} className={Style.leftcol}>
          禁用人：{dataSource?.disableMan}
        </Col>
        <Col span={12} className={Style.rightcol}>
          禁用时间：{dataSource?.disableTime}
        </Col>
      </Row>
      {/* <Row className={Style.rowitem}>
				<Col span={12} className={Style.leftcol}>
					启用人：{dataSource?.disableMan}
				</Col>
				<Col span={12} className={Style.rightcol}>
					启用时间：{dataSource?.disableMan}
				</Col>
			</Row> */}
    </div>
  )
}

export default Record
